import { useState, useEffect, useCallback } from 'react';

const useIntersection = (options) => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const [target, setTarget] = useState(null);
    const [root, setRoot] = useState(null);

    const observerCallback = useCallback(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
    }, []);

    useEffect(() => {
        if (!target || !root) return;

        const observer = new IntersectionObserver(observerCallback, {
            ...options,
            root,
        });

        observer.observe(target);

        return () => observer.disconnect();
    }, [target, root, observerCallback, options]);

    return [setTarget, isIntersecting, setRoot];
};

export default useIntersection;
